import _ from "lodash";
import {commonMutations} from "./common/commonMutations";

export const defaultModule = {
    namespaced: true,
    state: {
        path: null,
        apiPath: null,
        authPath: null,
        afterAuthPath: null,
        authApiPath: null,
        logo: null,
        appName: null,
        data: {}
    },
    mutations: {
        ...commonMutations,

        setDefaults(state, payload){
            for (const [objKey, objValue] of Object.entries(payload)) {
                state[_.camelCase(objKey)] = objValue && typeof objValue === 'object' && !Array.isArray(objValue)?
                    {...objValue}: objValue;
            }
        },
        setDefaultData(state, payload = {}) {
            state.data = {...payload};
        },
        updateDataItem(state, {key, value}) {
            state.data[key] = value;
        },
    },
    getters: {
        data: (state) => state.data,
    }
}
